import { CEAttributeSpecBase } from './ce-attribute-spec-base'


export class CEAttributeSpec extends CEAttributeSpecBase {

}